import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './index.scss';

export default function Footer() {
  const { t } = useTranslation();

  // Obtenemos los datos de los archivos de traducción
  const addressDataList = t('footer.address.items', { returnObjects: true });
  const serviceMenuList = t('footer.services.items', { returnObjects: true });
  const linksMenuList = t('footer.links.items', { returnObjects: true });
  const policyMenuList = t('footer.policy.items', { returnObjects: true });
  
  // Estos datos no necesitan traducción, son constantes
  const socialBtnList = [
    {
      icon: 'fa6-brands:linkedin-in',
      href: '/',
    },
    {
      icon: 'fa6-brands:twitter',
      href: '/',
    },
    {
      icon: 'fa6-brands:youtube',
      href: '/',
    },
    {
      icon: 'fa6-brands:facebook-f',
      href: '/',
    },
  ];
  
  return (
    <footer
      className="cs_fooer cs_bg_filed"
      style={{ backgroundImage: 'url(/images/footer_bg.jpeg)' }}
    >
      <div className="cs_fooer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <div className="cs_text_widget">
                  <img className='cs_footer_img' src="/images/unalom/logo_unalome_02.png" alt={t('footer.logoAlt')} />
                </div>
                <ul className="cs_menu_widget cs_mp0">
                  {addressDataList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">{t('footer.services.title')}</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {serviceMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">{t('footer.links.title')}</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {linksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">{t('footer.newsletter.title')}</h2>
                <div className="cs_newsletter cs_style_1">
                  <div className="cs_newsletter_text">
                    {t('footer.newsletter.description')}
                  </div>
                  <form action="#" className="cs_newsletter_form">
                    <input
                      type="email"
                      className="cs_newsletter_input"
                      placeholder={t('footer.newsletter.placeholder')}
                    />
                    <button className="cs_btn cs_style_1">
                      {t('footer.newsletter.buttonText')}
                      <span>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="cs_bottom_footer">
          <div className="cs_bottom_footer_left">
            <div className="cs_social_btns cs_style_1">
              {socialBtnList.map((item, index) => (
                <Link to={item.href} className="cs_center" key={index}>
                  <Icon icon={item.icon} />
                </Link>
              ))}
            </div>
          </div>
          <div className="cs_copyright">{t('footer.copyright')}</div>
          <div className="cs_bottom_footer_right">
            <ul className="cs_footer_links cs_mp0">
              {policyMenuList.map((item, index) => (
                <li key={index}>
                  <Link to={item.href}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
